import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=2c3ae932&scoped=true"
import script from "./Heatmap.vue?vue&type=script&lang=js"
export * from "./Heatmap.vue?vue&type=script&lang=js"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=2c3ae932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ae932",
  null
  
)

export default component.exports